import styled from 'styled-components';

import { Button } from 'components/Toolkit/Button';

const CloseButton = styled(Button)`
  padding: 0;
  cursor: pointer;
  width: 32px;
  height: 32px;
  color: ${({ theme }) => theme.colors.GREY_DARK};
  // Position close button and its contents at the top of the container
  align-self: start;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Header = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export { Header, CloseButton };
